import React from "react";
import {Link} from "react-router-dom";
import styles from "./HierarchyContextTransition.module.css";
import {HierarchyContextSource} from "../../../../../../../api/generated";

interface HierarchyContextValueProps {
    publicId?: string
    source?: HierarchyContextSource
    pathPrefix: "/franchises" | "/locations"
}

export const HierarchyContextValue: React.FC<HierarchyContextValueProps> = ({
                                                                               publicId,
                                                                               source,
                                                                               pathPrefix
                                                                           }) => {
    return <>
        {publicId && <Link className={styles.link} to={`${pathPrefix}/${publicId}`}>{publicId}</Link>}
        {source && <span> ({formatContextSource(source)})</span>}
    </>
}

const formatContextSource = (source: HierarchyContextSource): string => {
    switch (source) {
        case HierarchyContextSource.BackendLocked:
            return "Backend locked";
        case HierarchyContextSource.ChatSelected:
            return "Chat selected";
        case HierarchyContextSource.SystemInferred:
            return "System inferred";
        default:
            return source;
    }
}
